/* global location */
import { getFetchWrapper } from '../../utils/fetchHelpers'
import { getRoutePath, getPathParams } from '../../utils/urlHelpers'
import { getLocaleFromPath, stripLocaleFromPath } from '../../utils/localeHelpers'
import { connectModalFilterListeners, hideModalLoading } from './filters/modalWidgets'
import { customizeSearchInputs, initializeDimensionsApplyButton, initializePriceApplyButton, setSelectedCategoryCheckmark } from '../../utils/search/filters'
import setTruncatedSections from '../../src/truncatedSections'
import { titleCase } from '../../utils/stringHelpers'

function setSeoContent (data, nbHits) {
  const contentContainers = Array.from(document.getElementsByClassName('vjs-seo-content-container'))
  const contentTitle = document.querySelector('[data-id="content-title"]')
  const contentDescription = document.querySelector('[data-id="search-content-description"]')
  const titleContainer = document.getElementById('content_title_container')
  const seoTitleIsNotAlreadyOnPage = data.title && contentTitle && contentTitle.innerText.trim() !== data.title.trim()
  const description = getDescriptionFromPath(data.key, nbHits)

  if (contentTitle) {
    if (seoTitleIsNotAlreadyOnPage) {
      contentTitle.innerHTML = data.title
      contentTitle.setAttribute('data-content-route', data.key) // assign paramterized route for lookup
    }

    if (data.title) {
      titleContainer.classList.remove('hidden')
    } else {
      titleContainer.classList.add('hidden')
    }
  }

  if (contentDescription) {
    const contentDescriptionText = Array.from(contentDescription.getElementsByClassName('vjs-search-content-description-text'))[0]
    if (contentDescriptionText) contentDescriptionText.innerHTML = description

    if (description) {
      contentDescription.classList.remove('hidden')
    } else {
      contentDescription.classList.add('hidden')
    }
  }

  if (data.title || data.quick_links || description) {
    contentContainers.forEach(contentContainer => contentContainer.classList.remove('hidden'))
  } else {
    contentContainers.forEach(contentContainer => contentContainer.classList.add('hidden'))
  }
}

function getDescriptionFromPath (path, nbHits) {
  const taxonomyParentRegex = /^(?:furniture|home-decor|lighting|garden-decor|garden-lighting|garden-furniture|textiles|art|home-fixtures)(?:\/|$).*/

  if (path.includes('/style/')) {
    return getStyleDescription(path)
  } else if (path.includes('/brand/')) {
    return getBrandDescription(path)
  } else if (path.includes('/designer/')) {
    return getDesignerDescription(path)
  } else if (path.includes('/location/')) {
    return getLocationDescription(path)
  } else if (path.includes('/material/')) {
    return getMaterialDescription(path)
  } else if (path.includes('/colour/')) {
    return getColourDescription(path)
  } else if (path.includes('/period/')) {
    return getPeriodDescription(path)
  } else if (path.includes('/doors-type/')) {
    return getDoorTypeDescription(path)
  } else if (path.includes('/shape/')) {
    return getShapeDescription(path)
  } else if (path.startsWith('collections/')) {
    return getCollectionsDescription(path)
  } else if (path.startsWith('room-type/')) {
    return getRoomTypeDescription(path)
  } else if (taxonomyParentRegex.test(path)) {
    return getTaxonomyParentDescription(path, nbHits)
  } else {
    return ''
  }
}

function getStyleDescription (path) {
  return `Buy and sell unique ${getModifierValue(path)?.toLowerCase()} ${findModifierName(path, 'style')?.toLowerCase()} from iconic designers.`
}
function getBrandDescription (path) {
  return `Buy and sell vintage ${findModifierName(path, 'brand')?.toLowerCase()} from ${getModifierValue(path)}.`
}
function getDesignerDescription (path) {
  return `Buy and sell vintage ${findModifierName(path, 'designer')?.toLowerCase()} from ${getModifierValue(path)}.`
}
function getLocationDescription (path) {
  return `Buy and sell vintage ${findModifierName(path, 'location')?.toLowerCase()} from top sellers in ${getModifierValue(path)}.`
}
function getMaterialDescription (path) {
  return `Buy and sell vintage ${getModifierValue(path)?.toLowerCase()} ${findModifierName(path, 'material')?.toLowerCase()} from top designers.`
}
function getColourDescription (path) {
  return `Buy and sell vintage ${getModifierValue(path)?.toLowerCase()} ${findModifierName(path, 'colour')?.toLowerCase()} from top designers.`
}
function getPeriodDescription (path) {
  return `Buy and sell authentic and high quality ${getModifierValue(path)?.toLowerCase()} ${findModifierName(path, 'period')?.toLowerCase()} from top sellers in the UK and Europe.`
}
function getDoorTypeDescription (path) {
  return `Buy and sell vintage ${getModifierValue(path)?.toLowerCase()} ${findModifierName(path, 'doors-type')?.toLowerCase()} from the UK and Europe’s top sellers.`
}
function getShapeDescription (path) {
  return `Buy and sell vintage ${getModifierValue(path)?.toLowerCase()} ${findModifierName(path, 'shape')?.toLowerCase()} from the UK and Europe’s top sellers.`
}
function getTaxonomyParentDescription (path, nbHits) {
  return `Buy and sell Vintage ${getModifierValue(path)?.toLowerCase()}. More than ${nbHits} products in stock from the UK and Europe’s top sellers.`
}
function getCollectionsDescription (path) {
  return `Buy and sell unique items from our ${getModifierValue(path)} collection. Exclusive pieces from the UK and Europe’s top sellers.`
}
function getRoomTypeDescription (path) {
  return `Buy and sell unique vintage pieces for your ${getModifierValue(path)?.toLowerCase()}. Find iconic pieces from renowned designers.`
}

function findModifierName (path, modifier) {
  const pathArray = path.split('/')
  const modifierIndex = pathArray.indexOf(modifier)

  return pathArray[modifierIndex - 1]?.split('-')?.join(' ')
}

function getModifierValue (path) {
  return path
    .split('/')
    .pop().split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

function setSeoDescription (data) {
  const contentBodyDescription = document.querySelector('[data-id="content-body-container"]')
  const descriptionContainer = document.getElementById('content_body_container')

  if (contentBodyDescription && data.seo_description) {
    contentBodyDescription.innerHTML = data.seo_description
  }

  if (!descriptionContainer) return

  if (data.seo_description) {
    descriptionContainer.classList.remove('hidden')
  } else {
    descriptionContainer.classList.add('hidden')
  }
}

function setQuickLinks (data, quickLinkContainer) {
  if (!quickLinkContainer) return

  const quickLinks = data.quick_links

  if (!quickLinks || quickLinks.length === 0) {
    quickLinkContainer.classList.add('hidden')
    return
  }

  const quickLinksHtml = quickLinks.map(quickLink => `
      <a class="vsd-chip__filter vt-quicklink" href="${quickLink.url}">${titleCase(quickLink.name)}</a>
    `).join('')

  quickLinkContainer.classList.remove('hidden')
  const seoContentsContainer = document.querySelector('.vjs-seo-content-container')
  if (seoContentsContainer) seoContentsContainer.classList.remove('hidden')
  quickLinkContainer.innerHTML = `<div class="flex items-center flex-wrap mt-24 pb-20 gap-16 max-887:flex-nowrap max-887:overflow-x-auto ">${quickLinksHtml}</div>`
}

function setSeoMetaTags (data) {
  const fullRouteUrl = location.protocol + '//' + location.host + '/' + data.key

  const metaTitleElement = document.querySelector('title')
  const metaDescriptionElement = document.querySelector("meta[name='description']")
  const ogTitleElement = document.querySelector("meta[property='og:title']")
  const ogDescriptionElement = document.querySelector("meta[property='og:description']")
  const ogUrlElement = document.querySelector("meta[property='og:url']")
  const twitterTitleElement = document.querySelector("meta[name='twitter:title']")
  const twitterDescriptionElement = document.querySelector("meta[name='twitter:description']")

  metaTitleElement.innerHTML = data.meta_title
  metaDescriptionElement.content = data.meta_description
  ogTitleElement.content = data.meta_title
  ogDescriptionElement.content = data.meta_description
  ogUrlElement.content = fullRouteUrl
  twitterTitleElement.content = data.meta_title
  twitterDescriptionElement.content = data.meta_description
}

function shouldRemoveLastLevelUrl (routeArray) {
  if (!routeArray) return false

  const rootLevelPlp = routeArray[1]
  const lastLevelPlp = routeArray[routeArray.length - 1]
  const duplicatedContentArray = ['doors', 'fireplaces', 'other-desk-accessories', 'other-decorative-objects', 'flower-pots', 'other-toys-and-games']

  return duplicatedContentArray.includes(lastLevelPlp) &&
    !['showcases', 'collections', 'room-type'].includes(rootLevelPlp)
}

function shouldKeepPaginationParam (routeArray) {
  if (!routeArray) return false

  const rootLevelPlp = routeArray[1]
  const testPaths = ['art', 'garden-furniture', 'home-decor', 'lighting', 'textiles', 'furniture',
    'home-fixtures', 'room-type', 'collections', 'garden-decor', 'garden-lighting', 'sellers']

  return testPaths.includes(rootLevelPlp)
}

function setCanonicalAndMetaTags (routeUrl, options) {
  const decodedUrl = decodeURIComponent(routeUrl)
  const canonicalElement = document.querySelector("link[rel='canonical']")
  const decodedUrlWithoutParams = decodedUrl.split('?')[0]
  const routeArray = decodedUrlWithoutParams.replace('//', '').split('/')
  const initialBaseUrl = decodedUrl.match(/(^(?:(?!\?).)*)/g).join('')

  // Used for testing canonical tags with pagination and filter params
  const isTestPath = shouldKeepPaginationParam(routeArray)

  // Experiment: Excludes last level if it's on duplicatedContentArray.
  // This is to avoid the URLs from being flagged
  // as duplicated content of upper level route
  const isDuplicatedContentRoute = shouldRemoveLastLevelUrl(routeArray)
  const baseUrl = isDuplicatedContentRoute ? initialBaseUrl.replace(/(?!.+\/)(.+)/, '') : initialBaseUrl

  // Just letting the page param pass through
  // won't detect if anything else comes after p=## (other facets)
  const paginationParam = decodedUrl.match(/p=\d+$/)

  setPrevNextMetaTags(baseUrl, options)

  if (!canonicalElement) return

  if (isTestPath && paginationParam) {
    const queryParams = paginationParam
    canonicalElement.href = `${baseUrl}?${queryParams.join('')}`
  } else {
    canonicalElement.href = baseUrl
  }
}

function setPrevNextMetaTags (baseUrl, options) {
  const { page, nbPages } = options.helper.lastResults

  // The page field from lastResults is an index starting at 0, need to add one to get currentPage
  const currentPage = page + 1
  const prevPage = page
  const nextPage = currentPage + 1

  const removePrevPageMetaTag = currentPage === 1
  const removeNextPageMetaTag = currentPage === nbPages

  setPageMetaTag('prev', baseUrl, prevPage, removePrevPageMetaTag)
  setPageMetaTag('next', baseUrl, nextPage, removeNextPageMetaTag)
}

function setPageMetaTag (key, baseUrl, pageValue, removePageMetaTag) {
  const hrefAttribute = pageValue === 1 ? baseUrl : `${baseUrl}?p=${pageValue}`
  const pageMetaTag = document.querySelector(`link[rel='${key}']`)

  if (pageMetaTag && removePageMetaTag) {
    pageMetaTag.remove()
  } else if (pageMetaTag) {
    pageMetaTag.setAttribute('href', hrefAttribute)
  } else if (!pageMetaTag && !removePageMetaTag) {
    const link = document.createElement('link')
    link.rel = key
    link.href = hrefAttribute

    document.querySelector('head').appendChild(link)
  }
}

export function onRenderCustomisations (options, search) {
  connectModalFilterListeners(options, search)

  customizeSearchInputs()
  initializeDimensionsApplyButton()
  initializePriceApplyButton()
  setSelectedCategoryCheckmark()
  hideModalLoading()

  const routeUrl = search.createURL()
  setCanonicalAndMetaTags(routeUrl, options)

  const seoFullRoutePath = getRoutePath(routeUrl)
  if (seoFullRoutePath === '/search') {
    return
  }

  const contentTitle = document.querySelector('[data-id="content-title"]')
  if (contentTitle === null) return

  const seoCurrentRoute = contentTitle.getAttribute('data-content-route') || ''
  const urlParams = getPathParams(routeUrl)
  const quickLinkContainer = document.querySelector('.vjs-quick-links')
  // do not change content on SEOroutes on sale and new
  if (onExcludedPaths(seoFullRoutePath)) return
  if (currentRouteMatchesFullRoute(seoCurrentRoute, seoFullRoutePath)) return

  contentTitle.removeAttribute('data-content-route')
  const locale = getLocaleFromPath(seoFullRoutePath) || 'en'
  // Hotwire candidate
  getFetchWrapper(`/body_content?path=${encodeURIComponent(seoFullRoutePath)}&query=${encodeURIComponent(urlParams)}&locale=${encodeURIComponent(locale)}`)
    .then((response) => response.json())
    .then((data) => {
      setSeoContent(data, options.results.nbHits)
      setSeoDescription(data)
      setQuickLinks(data, quickLinkContainer)
      setTruncatedSections()
      setSeoMetaTags(data)
    })
}

function onExcludedPaths (seoFullRoutePath) {
  const excludedPaths = ['/new', '/sale/all']
  return excludedPaths.includes(stripLocaleFromPath(seoFullRoutePath))
}

function normalizeRoutePath (path) {
  if (!path) return ''
  // Server-rendered `data-content-route` is locale-free and includes a leading slash;
  // post-fetch `data.key` has no leading slash; `search.createURL()` includes the locale.
  // Normalize all three so the comparison is meaningful regardless of source.
  const withLeadingSlash = path.startsWith('/') ? path : '/' + path
  return stripLocaleFromPath(withLeadingSlash).replace(/['.]/g, '')
}

function currentRouteMatchesFullRoute (seoCurrentRoute, seoFullRoutePath) {
  return normalizeRoutePath(seoCurrentRoute) === normalizeRoutePath(seoFullRoutePath)
}
